module.exports = __webpack_public_path__ + "img/client27.87a4c14c.svg";